import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bank } from '../../../App/services/API';
import RedirectToBankForm from 'modules/Payment/components/RedirectToBank/components/RedirectToBankForm';
import { INPUT_NAMES_ARRAY } from 'modules/Payment/components/RedirectToBank/constants';
import { formDataMapper } from 'modules/Payment/components/RedirectToBank/requestDataMappers';

export default class RedirectToBank extends Component {
  static propTypes = {
    payment: PropTypes.object,
    cardId: PropTypes.string,
    bankId: PropTypes.string,
    recurrent: PropTypes.string,
    acceptedPersoDataProcessing: PropTypes.string,
    createPopupOnMount: PropTypes.bool,
    children: PropTypes.func,
    childInn: PropTypes.string,
  };

  static defaultProps = {
    createPopupOnMount: true,
  };

  state = {
    loading: false,
    error: null,
  };

  $redirectComponent = React.createRef();

  componentDidMount() {
    this.props.createPopupOnMount && this.createRedirect();
  }

  handleForcePayment = () => {
    this.createRedirect();
  };

  getPaymentData(payment) {
    return payment;
  }

  async fetchData() {
    const { bankId, acceptedPersoDataProcessing, cardId, payment, childInn } = this.props;
    const paymentData = this.getPaymentData(payment);
    return bank(paymentData, {
      bankId,
      acceptedPersoDataProcessing,
      cardId,
      childInn,
    });
  }

  createRedirect = async () => {
    const { cardId } = this.props;
    const redirectComponent = this.$redirectComponent.current;

    this.setState({ loading: true, error: null });
    const result = await this.fetchData();
    if (result.isOk) {
      const formData = formDataMapper({ ...result.data, cardId });
      this.setState({ formData, bankActionUrl: result.data.url }, this.formSubmitHandler);
    } else {
      redirectComponent && redirectComponent.handleError();
      this.setState({ error: result.error });
    }
    this.setState({ loading: false });
  };

  formSubmitHandler = () => {
    const { formData } = this.state;
    const redirectComponent = this.$redirectComponent.current;
    if (redirectComponent) {
      redirectComponent.formSubmit(formData, this.isGpbExtended());
    }
  };

  isGpbExtended() {
    const { bankId } = this.props;
    return bankId === 'gpb-extended';
  }

  render() {
    const { bankActionUrl, loading, error } = this.state;
    const { children } = this.props;
    return (
      <React.Fragment>
        {children &&
          children({
            handleForcePayment: this.handleForcePayment,
            loading: loading,
            error: error,
            bankActionUrl,
          })}

        {bankActionUrl ? (
          <RedirectToBankForm
            bankActionUrl={bankActionUrl}
            encType={this.isGpbExtended() ? 'text/plain' : null}
            formInputNames={INPUT_NAMES_ARRAY}
            ref={this.$redirectComponent}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
